import React, { Fragment, useEffect } from "react";
import Loader from "../../../common/Loader"
import { CLASSNAME_P_B, CLASSNAME_P_T, CLASSNAME_P_L, CLASSNAME_P_R, CLASSNAME_M_B, CLASSNAME_M_T, CLASSNAME_M_L, CLASSNAME_M_R } from '../../../constant/bannerItems'
import DeleteIcon from '@material-ui/icons/Delete';
import ColorPicker from "material-ui-color-picker";
import { List, makeStyles, ListItem, ListItemText, ListItemSecondaryAction, Button, TextField, FormControl, Select, MenuItem, FormControlLabel, Checkbox } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 600,
        backgroundColor: theme.palette.background.paper,
    },
    createUser: {
        width: '100%',
        maxWidth: 800,
    },
    textField: {
        width: '40ch',
    }
}));

const TestimonialForm = ({ testimonialId, handleCheckboxInputChange, setImageFile, resetColor, handleFileInputChange, setImage, isLoading, handleClose, inputs, handleInputChange, handleColorPicker, handleSubmit, errors, fromEditAction, deleteImage, bgImage, thumbImage }) => {

    const classes = useStyles();
    const errorClass = {
        color: "red",
    }

    const onSubmit = () => {
        handleSubmit()
    }


    return (
        <Fragment>
            {isLoading && (
                <Loader />
            )}
            {fromEditAction && (
                <div className="banner-form" style={{ 'minHeight': '52vh' }}
                >
                    <form className="banner-form-style">
                        <List>
                            {fromEditAction === 'bgImage' && (
                                <>
                                    <ListItem className="mb-35">
                                        <ListItemText id="switch-list-label-wifi" primary="Padding Top" />
                                        <ListItemSecondaryAction className="width-57">
                                            <FormControl variant="outlined" className={classes.textField}>
                                                <Select labelId="demo-simple-select-outlined-label" value={inputs.paddingTop}
                                                    onChange={handleInputChange}
                                                    name="paddingTop">
                                                    {CLASSNAME_P_T && CLASSNAME_P_T.length && Object.keys(CLASSNAME_P_T).map((data, index) => {
                                                        return <MenuItem value={CLASSNAME_P_T[data].value}> {CLASSNAME_P_T[data].label}</MenuItem>
                                                    })}
                                                    {!CLASSNAME_P_T.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </ListItemSecondaryAction>
                                    </ListItem>

                                    <ListItem className="mb-35">
                                        <ListItemText id="switch-list-label-wifi" primary="Padding Bottom" />
                                        <ListItemSecondaryAction className="width-57">
                                            <FormControl variant="outlined" className={classes.textField}>
                                                <Select labelId="demo-simple-select-outlined-label" value={inputs.paddingBottom}
                                                    onChange={handleInputChange}
                                                    name="paddingBottom">
                                                    {CLASSNAME_P_B && CLASSNAME_P_B.length && Object.keys(CLASSNAME_P_B).map((data, index) => {
                                                        return <MenuItem value={CLASSNAME_P_B[data].value}> {CLASSNAME_P_B[data].label}</MenuItem>
                                                    })}
                                                    {!CLASSNAME_P_B.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem className="mb-35">
                                        <ListItemText id="switch-list-label-wifi" primary="Padding Left" />
                                        <ListItemSecondaryAction className="width-57">
                                            <FormControl variant="outlined" className={classes.textField}>
                                                <Select labelId="demo-simple-select-outlined-label" value={inputs.paddingLeft}
                                                    onChange={handleInputChange}
                                                    name="paddingLeft">
                                                    {CLASSNAME_P_L && CLASSNAME_P_L.length && Object.keys(CLASSNAME_P_L).map((data, index) => {
                                                        return <MenuItem value={CLASSNAME_P_L[data].value}> {CLASSNAME_P_L[data].label}</MenuItem>
                                                    })}
                                                    {!CLASSNAME_P_L.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem className="mb-35">
                                        <ListItemText id="switch-list-label-wifi" primary="Padding Right" />
                                        <ListItemSecondaryAction className="width-57">
                                            <FormControl variant="outlined" className={classes.textField}>
                                                <Select labelId="demo-simple-select-outlined-label" value={inputs.paddingRight}
                                                    onChange={handleInputChange}
                                                    name="paddingRight">
                                                    {CLASSNAME_P_R && CLASSNAME_P_R.length && Object.keys(CLASSNAME_P_R).map((data, index) => {
                                                        return <MenuItem value={CLASSNAME_P_R[data].value}> {CLASSNAME_P_R[data].label}</MenuItem>
                                                    })}
                                                    {!CLASSNAME_P_R.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem className="mb-35">
                                        <ListItemText id="switch-list-label-wifi" primary="Margin Top" />
                                        <ListItemSecondaryAction className="width-57">
                                            <FormControl variant="outlined" className={classes.textField}>
                                                <Select labelId="demo-simple-select-outlined-label" value={inputs.marginTop}
                                                    onChange={handleInputChange}
                                                    name="marginTop">
                                                    {CLASSNAME_M_T && CLASSNAME_M_T.length && Object.keys(CLASSNAME_M_T).map((data, index) => {
                                                        return <MenuItem value={CLASSNAME_M_T[data].value}> {CLASSNAME_M_T[data].label}</MenuItem>
                                                    })}
                                                    {!CLASSNAME_M_T.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem className="mb-35">
                                        <ListItemText id="switch-list-label-wifi" primary="Margin Bottom" />
                                        <ListItemSecondaryAction className="width-57">
                                            <FormControl variant="outlined" className={classes.textField}>
                                                <Select labelId="demo-simple-select-outlined-label" value={inputs.marginBottom}
                                                    onChange={handleInputChange}
                                                    name="marginBottom">
                                                    {CLASSNAME_M_B && CLASSNAME_M_B.length && Object.keys(CLASSNAME_M_B).map((data, index) => {
                                                        return <MenuItem value={CLASSNAME_M_B[data].value}> {CLASSNAME_M_B[data].label}</MenuItem>
                                                    })}
                                                    {!CLASSNAME_M_B.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </ListItemSecondaryAction>
                                    </ListItem>

                                    <ListItem className="mb-35">
                                        <ListItemText id="switch-list-label-wifi" primary="Margin Right" />
                                        <ListItemSecondaryAction className="width-57">
                                            <FormControl variant="outlined" className={classes.textField}>
                                                <Select labelId="demo-simple-select-outlined-label" value={inputs.marginRight}
                                                    onChange={handleInputChange}
                                                    name="marginRight">
                                                    {CLASSNAME_M_R && CLASSNAME_M_R.length && Object.keys(CLASSNAME_M_R).map((data, index) => {
                                                        return <MenuItem value={CLASSNAME_M_R[data].value}> {CLASSNAME_M_R[data].label}</MenuItem>
                                                    })}
                                                    {!CLASSNAME_M_R.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem className="mb-35">
                                        <ListItemText id="switch-list-label-wifi" primary="Margin Left" />
                                        <ListItemSecondaryAction className="width-57">
                                            <FormControl variant="outlined" className={classes.textField}>
                                                <Select labelId="demo-simple-select-outlined-label" value={inputs.marginLeft}
                                                    onChange={handleInputChange}
                                                    name="marginLeft">
                                                    {CLASSNAME_M_L && CLASSNAME_M_L.length && Object.keys(CLASSNAME_M_L).map((data, index) => {
                                                        return <MenuItem value={CLASSNAME_M_L[data].value}> {CLASSNAME_M_L[data].label}</MenuItem>
                                                    })}
                                                    {!CLASSNAME_M_L.length && (<MenuItem value=" "> No Data</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem className="mb-35">
                                        <ListItemText id="switch-list-label-wifi" primary="Full Section" />
                                        <ListItemSecondaryAction>
                                            <FormControlLabel
                                                className={classes.textField}
                                                control={<Checkbox checked={inputs.fullSection} onChange={handleCheckboxInputChange} name="fullSection" className="ml-2 mt-1" />}
                                            />

                                        </ListItemSecondaryAction>
                                    </ListItem>
                                </>
                            )}

                            {fromEditAction === 'bgImage' && (
                                <>
                                    <ListItem className={`mt-20 mb-35`} style={{ height: "5em" }}>
                                        <ListItemText id="switch-list-label-wifi" primary="Background Image" />
                                        <ListItemSecondaryAction>

                                            <FormControl variant="outlined" className={classes.textField}>
                                                <div className="uploadedImg">
                                                    <input onChange={(e) => setImageFile(e, 'bgImage')}
                                                        type="file"
                                                        name="bgImage"
                                                    />
                                                    {bgImage != "" && bgImage != 'undefined' && (
                                                        <>
                                                            <img height="50px" width="50px" src={bgImage} className="mt-15"></img>
                                                            <DeleteIcon
                                                                className="text-error"
                                                                title={"Delete"}
                                                                onClick={() => {
                                                                    setImage("", 'bgImage')
                                                                    deleteImage('bgImage')
                                                                }}
                                                                aria-label=""
                                                            />
                                                        </>
                                                    )}
                                                </div>
                                            </FormControl>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem className="mb-35">
                                        <ListItemText id="switch-list-label-wifi" primary="Background color" />
                                        <div className="col-lg-4">
                                            <ColorPicker
                                                name="bgColor"
                                                defaultValue="select color"
                                                value={inputs.bgColor}
                                                onChange={color => { handleColorPicker('bgColor', color) }}
                                            />
                                        </div>
                                        <div className="col-lg-3">
                                            <p>{inputs.bgColor != undefined && (inputs.bgColor)}</p>
                                        </div>
                                        <DeleteIcon
                                            className="text-error"
                                            title={"Delete"}
                                            onClick={() => {
                                                resetColor("", 'bgColor')
                                            }}
                                            aria-label=""
                                        />
                                    </ListItem>

                                </>
                            )}

                            {fromEditAction === 'thumbImage' && (
                                <>
                                    <ListItem className="mb-35">
                                        <ListItemText id="switch-list-label-wifi" primary="Thumb Image Height" /><br />
                                        <ListItemSecondaryAction>
                                            <TextField
                                                id="standard-number"
                                                type="number"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                size="medium"
                                                variant="outlined"
                                                fullWidth
                                                className={classes.textField}
                                                value={inputs.thumbImageHeight}
                                                onChange={handleInputChange}
                                                name="thumbImageHeight"
                                            />PX

                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem className={`mt-20 mb-35`} style={{ height: "5em" }}>
                                        <ListItemText id="switch-list-label-wifi" primary="Thumb Nail Image" />
                                        <ListItemSecondaryAction>
                                            <FormControl variant="outlined" className={classes.textField}>
                                                <div className="uploadedImg">

                                                    <input onChange={(e) => setImageFile(e, 'thumbImage')}
                                                        type="file"
                                                        name="thumbImage"
                                                    />
                                                    {thumbImage != "" && thumbImage != 'undefined' && (
                                                        <>
                                                            <img height="50px" width="50px" src={thumbImage} className="mt-15"></img>
                                                            <DeleteIcon
                                                                className="text-error"
                                                                title={"Delete"}
                                                                onClick={() => {
                                                                    setImage("", 'thumbImage')
                                                                    deleteImage('thumbImage')
                                                                }}
                                                                aria-label=""
                                                            />
                                                        </>
                                                    )}
                                                </div>
                                            </FormControl>
                                        </ListItemSecondaryAction>
                                    </ListItem>

                                </>
                            )}

                            <ListItem>
                                <button type="button" className="cancelButton" onClick={() => { handleClose() }}>Cancel</button>&nbsp;&nbsp;&nbsp;
                                <Button variant="contained" color="primary" className="bannerbutton" type="button" onClick={() => { onSubmit() }}> {testimonialId ? "Update" : "Save"}</Button>
                            </ListItem>
                        </List>

                    </form>
                </div>
            )}
        </Fragment>
    );
};

export default TestimonialForm;
